    import { configureStore } from "@reduxjs/toolkit";

    import locationReducer from "../reducers/LocationSlice";
    import bookingFormSlice from "../reducers/bookingFormSlice";
    import sessionTypeReducer from "../reducers/sessionTypeSlice";
    import KiidoBookingSlice from "../reducers/KiidoBookingSlice";

    const store = configureStore({

        reducer: {
            location: locationReducer,
            bookingForm: bookingFormSlice,
            sessionType: sessionTypeReducer,
            booking: KiidoBookingSlice,
        }
    });

    export default store;